export default __webpack_public_path__ + "static/media/phone.078b97ce.svg";